import store from 'store'
import { setMessage } from 'store/messageSlice'

export function showHttpToast(status, props) {
    let variant = 'info'
    let title = 'Información'
    let delay = undefined
    if (status === false || (typeof status === 'number' && status >= 400)) {
        variant = 'error'
        title = 'Error'
        delay = 10000
    } else if (status === true || (status >= 200 && status < 300)) {
        variant = 'success'
        title = 'Éxito'
    }
    store.dispatch(
        setMessage({
            global: true,
            severity: variant,
            title,
            detail: props.description,
            delay,
        }),
    )
}
